import { defineComponent } from "vue";
const _sfc_main = defineComponent({
  name: "ChartHistogram"
});
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "currentColor",
  viewBox: "0 0 24 24"
};
const _hoisted_2 = /* @__PURE__ */ _createElementVNode("path", { d: "M4.5 12C6.72953 12 7.6743 10.3118 8.50852 8.82203C9.35558 7.30807 10.0875 6 12 6C13.9125 6 14.6444 7.30807 15.4915 8.82203C16.3257 10.3118 17.2705 12 19.5 12H22.5V10.5H19.5C18.2153 10.5 17.6374 9.58447 16.8007 8.0892C15.9056 6.49072 14.7923 4.5 12 4.5C9.20767 4.5 8.09438 6.49072 7.19933 8.0892C6.36255 9.58447 5.78468 10.5 4.5 10.5H3V1.5H1.5V21C1.5 21.3978 1.65804 21.7794 1.93934 22.0607C2.22064 22.342 2.60218 22.5 3 22.5H22.5V21H21V16.5H19.5V21H16.4994L16.5 15H15V21H12V12H10.5V21H7.4994L7.5 15H6V21H3V12H4.5Z" }, null, -1);
const _hoisted_3 = [
  _hoisted_2
];
function _sfc_render(_ctx, _cache, $props, $setup, $data, $options) {
  return _openBlock(), _createElementBlock("svg", _hoisted_1, _hoisted_3);
}
import _export_sfc from "/plugin-vue/export-helper";
export default /* @__PURE__ */ _export_sfc(_sfc_main, [["render", _sfc_render], ["__file", "/Users/yimingtian/projects/ym/yimian-ui/packages/icons/src/ChartHistogram.vue"]]);
